export default __webpack_public_path__ + "static/media/nw.1807d5c9.png";